import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "lodash";
import AgentsSelect from "../../../../../agents/components/agents-select";
import ApplicationListFilters from "./application-list-filters";
import { CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationsListActions",
  components: {
    AgentsSelect,
    ApplicationListFilters
  },
  props: {
    currentAgent: {
      type: String,
      default: ""
    },
    loggedInAgent: {
      type: String,
      default: ""
    },
    searchString: {
      type: String,
      default: ""
    },
    showAgents: {
      type: Boolean,
      default: true
    },
    isPropertyAccount: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY])), {}, {
    isViewOnly() {
      return this.CURRENT_ACCOUNT_ACCESS_RIGHTS_VIEW_ONLY;
    },
    searchText: {
      get() {
        return this.searchString;
      },
      set: debounce(function (text) {
        if (text.length && _trimInstanceProperty(text).call(text).length <= 2) return;
        this.$emit("search-client", _trimInstanceProperty(text).call(text));
      }, 300, {
        trailing: true
      })
    }
  }),
  methods: {
    agentSelected({
      username
    }) {
      this.$emit("change", username);
    },
    handleClick(action) {
      if (action === "add" && this.isViewOnly) return;
      this.$emit(action);
    },
    handleFilters(data) {
      this.$emit("filter", data);
    },
    clearFilter(data) {
      this.$refs.applicationFilters.clearFilter(data);
    }
  }
});